// extracted by mini-css-extract-plugin
module.exports = {"copy-content-wrapper":"TwoFactorConfigure__copy-content-wrapper___0+iKh","card-extension":"TwoFactorConfigure__card-extension___X+BbW"};